// extracted by mini-css-extract-plugin
module.exports = {"Title":"LottieView_Title__kVYe2","SubTitle":"LottieView_SubTitle__2N1ID","ForbiddenView":"LottieView_ForbiddenView__MUanE"};